export const HTTP_CODE_SUCCESS = 200;
export const HTTP_CODE_ERROR = 400;
export const HTTP_CODE_UNAUTHORIZED = 401;
export const HTTP_CODE_PAYMENT_REQUIRED = 402;
export const HTTP_CODE_FORBIDDEN = 403;
export const HTTP_CODE_CONFLICT = 409;
export const HTTP_CODE_GONE = 410;
export const HTTP_CODE_UNAVAILABLE_FOR_LEGAL_REASONS = 451;
export const HTTP_CODE_NOT_FOUND = 404;
